<template>
    <div>
        <v-toolbar color="primary">
            <v-toolbar-title class="ml-0 pl-3 white--text" style>
                <strong><span style="font-size:1.2rem;">Non Visa {{formData.type}} Certification</span></strong>
            </v-toolbar-title>
        </v-toolbar>
        <v-card class="elevation-1 pa-3 mr-10 ml-10 mt-10">
            <v-card-text>
                <v-form ref="certificationForm">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <header-text text="Personal information"
                                         icon="mdi-account"></header-text>
                        </v-flex>
                        <v-flex xs6>
                            <v-text-field
                                outlined
                                label="Full name *"
                                :rules="[rules.required]"
                                v-model="formData.name"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs6 class="pl-10 pr-5">
                          <new-date-picker
                              label="Date of birth *"
                              v-model="formData.dob"
                              :min-year="dateOfBirth.min_year"
                              :max-year="dateOfBirth.max_year"
                          />
                        </v-flex>
                        <v-flex xs6>
                            <v-select
                                :items="genders"
                                outlined
                                :rules="[rules.required]"
                                v-model="formData.gender"
                                label="Gender *"
                            ></v-select>
                        </v-flex>
                        <v-flex xs6 class="pl-2">
                            <file-input
                                :required="true"
                                label="User image *"
                                :show-image="true"
                                :fileSize="6144"
                                :valid_file_types="['jpg','jpeg','png']"
                                v-model="formData.user_image"

                            ></file-input>
                        </v-flex>
                        <v-flex xs6>
                            <v-select
                                :items="occupations"
                                item-value="name"
                                item-text="name"
                                outlined
                                v-model="formData.occupation"
                                :rules="[rules.required]"
                                label="Occupation *"
                            ></v-select>
                        </v-flex>

                        <v-flex xs6 class="pl-2">
                            <v-text-field
                                outlined
                                :rules="[rules.required,rules.international_number,rules.number]"
                                v-model="formData.contact_number"
                                label="Contact number *"
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12>
                            <header-text text="Passport information"
                                         icon="mdi-passport">
                            </header-text>
                        </v-flex>

                        <v-flex xs6>
                            <v-text-field
                                outlined
                                label="Passport number *"
                                :rules="[rules.required]"
                                v-model="formData.passport_number"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs6 class="pl-10 pr-5">
                          <new-date-picker
                              label="Passport validity *"
                              v-model="formData.passport_validity"

                          />
                        </v-flex>
                        <v-flex xs6>
                            <file-input label="Passport image *" :show-image="true"
                                        :fileSize="6144"
                                        :required="true"
                                        v-model="formData.passport_image"
                                        :valid_file_types="['jpg','jpeg','png']"></file-input>
                        </v-flex>


                        <v-flex xs12>
                            <header-text text="Certification information"
                                         :icon="formData.type === 'Departure' ? 'mdi-airplane-takeoff':'flight_land'">
                            </header-text>
                        </v-flex>
                        <v-flex xs4 class="pr-2">
                            <v-select
                                :items="['Arrival','Departure']"
                                label="Certification type *"
                                v-model="formData.type"
                                outlined
                            ></v-select>
                        </v-flex>
                      <v-flex xs4>
                        <v-autocomplete
                            :items="offices"
                            :label="formData.type === 'Arrival'?'Arrival Point *' :  'Departure Point *'"
                            :rules=[rules.required]
                            class="pl-2"
                            item-text="name"
                            item-value="id"
                            min="0"
                            outlined
                            v-model="formData.office"
                        />
                      </v-flex>
                      <v-flex xs4>
                        <v-autocomplete
                            :items="countries"
                            :label="formData.type === 'Arrival' ?  'Country Arrived from *' : 'Country Departed To'"
                            v-model="formData.country"
                            :rules="[rules.required]"
                            item-text="country_name"
                            item-value="country_name"
                            min="0"
                            outlined
                            class="pl-2"
                        ></v-autocomplete>
                      </v-flex>
                        <v-flex class="pl-3 pr-5" xs4>
                          <new-date-picker style="" @invalidCertificationDate="disableProceed"
                              :label="formData.type === 'Arrival' ? 'Arrived Date' : 'Departure Date'"
                              type="certificationDate"
                              v-model="formData.date"

                          />
                        </v-flex>
                        <v-flex xs4>
                          <v-combobox
                              :items="reasons"
                              v-model="formData.purpose_of_visit"
                              label="Purpose of visit *"
                              :rules="[rules.required]"
                              class="pl-2"
                              outlined
                          />
                        </v-flex>
                      <v-flex xs4>
                        <v-autocomplete
                            :items="reason_for_certification"
                            v-model="formData.reason_for_certification"
                            label="Reason for certification *"
                            :rules=[rules.required]
                            class="pl-2"
                            outlined
                        />
                      </v-flex>
                    </v-layout>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :disabled="disableBtn"
                    color="primary"
                    @click="proceed"
                >Proceed
                </v-btn>
            </v-card-actions>
        </v-card>

    </div>
</template>

<script>
    import FileInput from "../../components/FileInput";
    import HeaderText from "../../components/HeaderText";
    import {validationMixin} from "../../mixins/validationMixin";
    import {mapActions} from "vuex";
    import {fetchDynamicValues} from "@/helpers/dynamicValueHelper";
    import NewDatePicker from "@/components/DatePickerNew";

    export default {
        name: "CertificationForm",
        data() {
            return {
                valid: false,
                genders: ['Male', 'Female', 'Others'],
                formData: {
                    type: 'Arrival'
                },
              reasons: [],
              reason_for_certification: [],
              disableBtn:false
            }
        },
        props: ['certificationData'],
        mixins: [validationMixin],
        methods: {
          ...mapActions({
            fetchOffices: "Office/fetchOffices",
          }),
            proceed() {
                if (this.$refs.certificationForm.validate()) {
                    this.$emit('proceed', this.formData)
                }
            },
          disableProceed(value){
            this.disableBtn = value;
          }
        },
        computed: {
            occupations() {
                return this.$store.state.VisaSingle.occupationOptions;
            },
            countries() {
                return this.$store.state.CountryForTouristList.all;
            },
          offices() {
            return this.$store.state.Office.offices;
          },
          dateOfBirth() {
            const max_year = parseInt(new Date().toISOString().substr(0, 4));
            const min_year = parseInt(max_year) - 120;
            return {
              min_year,
              max_year
            }
          },
        },
        components: {
            FileInput, HeaderText,NewDatePicker
        },
        mounted() {
          fetchDynamicValues('PurposeOfVisa').then((data) => {
            this.reasons = data;
          });
          fetchDynamicValues('ReasonForCertification').then((data) => {
            this.reason_for_certification = data;
          })
            this.$store.dispatch('CountryForTouristList/fetchAll');

            if (this.certificationData.name !== undefined) {
                this.formData = this.certificationData;
            }

           this.$store.dispatch('fetchOffices');

        }
    }
</script>
